import api from "../api.js";

export const calculateWindowSize = (windowWidth) => {
    if (windowWidth >= 1200) {
        return 'lg';
    }
    if (windowWidth >= 992) {
        return 'md';
    }
    if (windowWidth >= 768) {
        return 'sm';
    }
    return 'xs';
};

export const SECTION_NAMES = Object.freeze({
    'AnalyticsSection': 0,
    'UserManagement': 1,
    'VideoManagement': 2,
    'WorkoutManagement': 3,
});
export default {
    namespaced: true,
    state: {
        menuSidebarCollapsed: false,
        screenSize: calculateWindowSize(window.innerWidth),
        activeSectionHeaderNavItems: [],
        lastActivePageNameForSection: [
            'AnalyticsDashboard',
            'UsersManagement',
            'VideoManagementLibrary',
            'WorkoutManagement'
        ],
        reportsData : {},
        reportsVideoData: {},
        setReportsGraphDataState: {},
        createAssignForm: {
            selectedUsers: [],
            programType: "daily",
            startDate: null,
            endDate: null,
            programName: null,
            programId: null,
            selectedVideos: []
        }
    },
    getters: {
        selectedVideos(state) {
            return state.createAssignForm.selectedVideos;
        },
        createAssignForm(state) {
            return state.createAssignForm;
        }
    },
    mutations: {
        setCreateAssignForm(state, data) {
            state.createAssignForm = Object.assign({}, state.createAssignForm, data);
        },
        setSelectedVideos(state, videos) {
            state.createAssignForm.selectedVideos = videos;
        },
        toggleMenuSidebar(state) {
            state.menuSidebarCollapsed = !state.menuSidebarCollapsed;
        },
        setWindowSize(state, payload) {
            state.screenSize = payload;
        },
        setHeaderNavItems(state, navItems = []) {
            state.activeSectionHeaderNavItems = navItems;
        },
        setLastActivePageName(state, {index, pageName}) {
            if (index > -1 && index < state.lastActivePageNameForSection.length) {
                state.lastActivePageNameForSection[index] = pageName;
            }
        },
        setReportsData(state, payload){
            state.reportsData = payload;
        },
        setReportsVideoData(state, payload){
            state.reportsVideoData = payload;
        },
        setReportsGraphData(state, payload){
            state.setReportsGraphDataState = payload
        },
        setReportsVideoDataLoadMore(state, payload){
            let obj = {
                totalPages : payload.totalPages,
                totalRecords : payload.totalRecords,
                rows: [...state.reportsVideoData.rows, ...payload.rows]
            }
            state.reportsVideoData = obj;
        }
    },
    actions: {
        async getLastActivePageName({state}, index) {
            if (index > -1 && index < state.lastActivePageNameForSection.length) {
                return state.lastActivePageNameForSection[index];
            }
        },
        async loadReprotsData({ commit, dispatch }, data){
            await api.loadReportsData(data).then(async (response) => {
                commit('setReportsData', response.data);
            }).catch((error) => {
                console.log("error");
            })
        },
        async loadReportsVideo({ commit, dispatch }, data){
            await api.loadReportsVideoData(data).then(async (response) => {
                if(data && data.addState){
                    commit('setReportsVideoDataLoadMore', response.data);
                }else{
                    commit('setReportsVideoData', response.data);
                }
            }).catch((error) => {
            })
        },
        async graphReprots({commit, dispatch}, data){
            await api.generateReports(data).then(async (response) => {
                commit('setReportsGraphData', response.data);
            }).catch((error) => {
                console.log("error");
            })
        }
    }
}